{
  "v3.elements.annuler": "Cancel",
  "v3.elements.autre_projet": "This item belongs to another project: opening it in its project…",
  "v3.elements.code.BACKLOG_ITEM_HAS_CHILDREN": "The item has children: tick “include children”.",
  "v3.elements.code.BACKLOG_ITEM_IN_ACTIVE_SPRINT": "The item or a descendant is committed to the active sprint: remove it from the sprint first.",
  "v3.elements.code.BACKLOG_ITEM_IN_RELEASE": "The item or a descendant is part of a release’s content.",
  "v3.elements.code.BACKLOG_ITEM_REFERENCED": "The item or a descendant is cited by a service incident.",
  "v3.elements.code.BACKLOG_MERGE_REASON_REQUIRED": "Say why these two items are duplicates (at least 5 characters).",
  "v3.elements.code.BACKLOG_MERGE_SAME_ITEM": "An item cannot be merged into itself.",
  "v3.elements.code.CHAMP_OBLIGATOIRE_MANQUANT": "A mandatory field of the level is missing.",
  "v3.elements.code.COMMENTAIRE_INTROUVABLE": "This comment no longer exists.",
  "v3.elements.code.CONFLIT_DE_VERSION": "The item changed since you read it: reload it before saving.",
  "v3.elements.code.CONTEXTE_INCOMPLET": "The rule context is incomplete: the action is refused.",
  "v3.elements.code.CREATEUR_N_APPROUVE_PAS": "An item’s author does not accept it themselves.",
  "v3.elements.code.DROIT_NON_TENU": "Your profile does not hold the right this action requires.",
  "v3.elements.code.ELEMENT_INTROUVABLE": "Item not found or not visible to you.",
  "v3.elements.code.FAVORI_TYPE_INCONNU": "This kind of object cannot be favourited yet.",
  "v3.elements.code.FIL_DEJA_RESOLU": "This thread is already resolved.",
  "v3.elements.code.FORMULE_ABSENTE": "The organisation has not set a score formula.",
  "v3.elements.code.GATE_NOT_SATISFIED": "A prerequisite of the requested state is not met.",
  "v3.elements.code.NIVEAU_HORS_MODELE": "This level does not exist in the project model.",
  "v3.elements.code.NOT_FOUND": "Item not found or not visible to you.",
  "v3.elements.code.PARENT_INCOMPATIBLE": "This parent does not accept this level in the project model.",
  "v3.elements.code.PREUVES_MANQUANTES": "The final state requires proofs that are still missing.",
  "v3.elements.code.PROVENANCE_NON_VALIDE": "The source document proof is not valid: reread the document before creating.",
  "v3.elements.code.REACTION_INCONNUE": "This reaction does not exist.",
  "v3.elements.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v3.elements.code.TRANSITION_HORS_MODELE": "This transition does not exist in the project model.",
  "v3.elements.code.VALIDATION_ERROR": "The input is not valid.",
  "v3.elements.code.VERSION_SOURCE_INCOMPATIBLE": "This source document version is not compatible.",
  "v3.elements.code.WORKSPACE_ARCHIVED": "The project is archived: nothing can be created.",
  "v3.elements.collab.activite": "Activity",
  "v3.elements.collab.activite_quoi": "activity",
  "v3.elements.collab.aucun_commentaire": "No comment.",
  "v3.elements.collab.aucun_retrolien": "No backlink.",
  "v3.elements.collab.aucune_activite": "No activity.",
  "v3.elements.collab.aucune_piece": "No attachment.",
  "v3.elements.collab.commentaires": "Comments",
  "v3.elements.collab.commentaires_quoi": "comments",
  "v3.elements.collab.commente": "Comment posted.",
  "v3.elements.collab.commenter": "Comment",
  "v3.elements.collab.deplier": "Expand: {{section}}",
  "v3.elements.collab.evenement.attachment": "attachment",
  "v3.elements.collab.evenement.comment": "comment",
  "v3.elements.collab.evenement.created": "created",
  "v3.elements.collab.evenement.status": "state change",
  "v3.elements.collab.fichier": "File to attach",
  "v3.elements.collab.fichier_invalide": "Empty file or larger than 10 MB.",
  "v3.elements.collab.joindre": "Attach file",
  "v3.elements.collab.joint": "File attached.",
  "v3.elements.collab.mentions_aide": "@username to mention: only people with access are notified.",
  "v3.elements.collab.piece_supprimee": "Attachment deleted.",
  "v3.elements.collab.pieces": "Attachments",
  "v3.elements.collab.pieces_quoi": "attachments",
  "v3.elements.collab.reaction.coeur": "Love",
  "v3.elements.collab.reaction.fete": "Hooray",
  "v3.elements.collab.reaction.merci": "Thanks",
  "v3.elements.collab.reaction.oeil": "Looking",
  "v3.elements.collab.reaction.pouce": "Agree",
  "v3.elements.collab.reaction.question": "Question",
  "v3.elements.collab.reaction_notee": "Reaction recorded.",
  "v3.elements.collab.reactions": "Reactions",
  "v3.elements.collab.replier": "Collapse: {{section}}",
  "v3.elements.collab.resolu": "thread resolved",
  "v3.elements.collab.resoudre": "Resolve thread",
  "v3.elements.collab.resume": "{{commentaires}} comments · {{pieces}} attachments · {{activite}} events",
  "v3.elements.collab.retroliens": "backlinks",
  "v3.elements.collab.retroliens_masques": "{{nombre}} other citations in objects you cannot read.",
  "v3.elements.collab.rouvrir": "Reopen thread",
  "v3.elements.collab.sans_notification": "These mentions will notify no one: {{mentions}}",
  "v3.elements.collab.supprimer": "Delete",
  "v3.elements.collab.supprimer_nom": "Delete {{nom}}",
  "v3.elements.collab.supprimer_piece_effet": "The file is removed from the item and from storage.",
  "v3.elements.collab.supprimer_piece_titre": "Delete “{{nom}}”?",
  "v3.elements.collab.taille_ko": "{{n}} KB",
  "v3.elements.collab.telecharger": "Download {{nom}}",
  "v3.elements.collab.titre": "Collaboration",
  "v3.elements.collab.votre_commentaire": "Your comment",
  "v3.elements.creer.afin_de": "So that",
  "v3.elements.creer.aucun_champ": "No mandatory field for this level.",
  "v3.elements.creer.aucun_parent": "No parent compatible with this level in the project.",
  "v3.elements.creer.bouton": "Create the item",
  "v3.elements.creer.champ_obligatoire": "Mandatory field of the level: {{champ}}",
  "v3.elements.creer.choisir_parent": "Choose a parent",
  "v3.elements.creer.compatible": "Level {{niveau}} is allowed under {{parent}}.",
  "v3.elements.creer.criteres": "Acceptance criteria",
  "v3.elements.creer.criteres_aide": "One criterion per line.",
  "v3.elements.creer.en_tant_que": "As a",
  "v3.elements.creer.incompatible": "Level {{niveau}} is not allowed under {{parent}}.",
  "v3.elements.creer.je_veux": "I want",
  "v3.elements.creer.niveau": "Level",
  "v3.elements.creer.niveau_hors_modele": "Level “{{niveau}}” does not exist in the project model.",
  "v3.elements.creer.origine.cadence": "Origin: cadence page",
  "v3.elements.creer.origine.fiche": "Origin: parent item page",
  "v3.elements.creer.origine.liste": "Origin: item list",
  "v3.elements.creer.origine.vue": "Origin: project overview",
  "v3.elements.creer.parent": "Parent: {{titre}} ({{niveau}})",
  "v3.elements.creer.parent_a_choisir": "Parent: to choose (this level is not a root)",
  "v3.elements.creer.parent_racine": "Parent: none (root item)",
  "v3.elements.creer.parent_seul": "Parent",
  "v3.elements.creer.provenance": "Source document: {{document}}, version {{version}}",
  "v3.elements.creer.racine": "None (root item)",
  "v3.elements.creer.recit": "Story ({{niveau}})",
  "v3.elements.creer.recit_hors_niveau": "Applies to level {{niveau}} only.",
  "v3.elements.creer.sans_provenance": "No source document provided.",
  "v3.elements.creer.succes": "Item created.",
  "v3.elements.creer.titre": "Create an item",
  "v3.elements.creer.titre_champ": "Title",
  "v3.elements.creer.titre_obligatoire": "The title is required.",
  "v3.elements.etat.chargement": "Loading: {{quoi}}…",
  "v3.elements.etat.en_cours": "In progress…",
  "v3.elements.etat.erreur": "Could not read: {{quoi}}.",
  "v3.elements.etat.introuvable": "Not found: {{quoi}}.",
  "v3.elements.etat.reessayer": "Retry",
  "v3.elements.etat.refus": "Access denied: {{quoi}}.",
  "v3.elements.fiche.a_accepter": "to accept",
  "v3.elements.fiche.accepte": "accepted",
  "v3.elements.fiche.accepter": "Accept the item",
  "v3.elements.fiche.affectations": "Assignments",
  "v3.elements.fiche.affectations_quoi": "available assignees",
  "v3.elements.fiche.affecte": "Assignment saved.",
  "v3.elements.fiche.affecter_cadence": "Assign cadence",
  "v3.elements.fiche.affecter_equipe": "Assign team",
  "v3.elements.fiche.affecter_responsable": "Assign",
  "v3.elements.fiche.affecter_rubrique": "Set component",
  "v3.elements.fiche.affecter_version": "Set release",
  "v3.elements.fiche.agent": "Agent {{nom}}",
  "v3.elements.fiche.ajouter_enfant": "Add a child",
  "v3.elements.fiche.ajouter_etiquette": "Add label",
  "v3.elements.fiche.analyser": "Analyse",
  "v3.elements.fiche.annuler_edition": "Discard changes",
  "v3.elements.fiche.appliquer_etat": "Apply the state",
  "v3.elements.fiche.aucun_axe": "No attached axis.",
  "v3.elements.fiche.aucun_doublon": "No absorbed duplicate.",
  "v3.elements.fiche.aucun_enfant": "No child.",
  "v3.elements.fiche.aucun_impact": "No impacted item.",
  "v3.elements.fiche.aucun_lien": "No link.",
  "v3.elements.fiche.aucun_niveau_enfant": "The model allows no level below this one.",
  "v3.elements.fiche.aucun_workflow": "No declared workflow.",
  "v3.elements.fiche.aucune_affectation": "No person, team or agent available.",
  "v3.elements.fiche.aucune_etiquette": "No label in the project.",
  "v3.elements.fiche.aucune_rubrique": "No component in the project.",
  "v3.elements.fiche.aucune_version": "No release in the project.",
  "v3.elements.fiche.auteur": "Author: {{auteur}}",
  "v3.elements.fiche.axe": "Organisation axis",
  "v3.elements.fiche.axes": "attached axes",
  "v3.elements.fiche.cadence": "Cadence",
  "v3.elements.fiche.cadence_heritee": "Cadence inherited from the parent: #{{id}}",
  "v3.elements.fiche.cas_probant": "Proving case",
  "v3.elements.fiche.cas_relie": "Case linked.",
  "v3.elements.fiche.choisir": "Choose",
  "v3.elements.fiche.choisir_etat": "Choose a state",
  "v3.elements.fiche.cible": "Target item",
  "v3.elements.fiche.classe": "Classification saved.",
  "v3.elements.fiche.classement": "Classification",
  "v3.elements.fiche.comprendre": "Understand and request access",
  "v3.elements.fiche.concevoir_cas": "Design test cases",
  "v3.elements.fiche.confirmer_workflow": "Launch “{{workflow}}”?",
  "v3.elements.fiche.criteres": "Acceptance criteria",
  "v3.elements.fiche.criteres_score": "Score criteria",
  "v3.elements.fiche.criteres_score_aide": "Per the organisation formula: code=value, comma-separated.",
  "v3.elements.fiche.decisions": "Decisions",
  "v3.elements.fiche.definition_termine": "definition of done",
  "v3.elements.fiche.deplier_impact": "Show impact",
  "v3.elements.fiche.depot": "Repository and delivery",
  "v3.elements.fiche.description": "Description",
  "v3.elements.fiche.detacher_nom": "Detach {{nom}}",
  "v3.elements.fiche.disponibles": "Available: {{membres}} people, {{equipes}} teams, {{agents}} agents.",
  "v3.elements.fiche.document_source": "Source document",
  "v3.elements.fiche.dod_atteinte": "Done, proven.",
  "v3.elements.fiche.dod_manques": "Missing:",
  "v3.elements.fiche.dod_non_applicable": "Definition of done not applicable.",
  "v3.elements.fiche.doublon": "{{titre}} (#{{id}}) absorbed by {{par}}: {{motif}}",
  "v3.elements.fiche.doublons": "absorbed duplicates",
  "v3.elements.fiche.edition": "Content",
  "v3.elements.fiche.element": "item",
  "v3.elements.fiche.enfants": "Children",
  "v3.elements.fiche.enfants_concernes": "Unfinished children: {{liste}}",
  "v3.elements.fiche.enregistre": "Saved.",
  "v3.elements.fiche.enregistrer": "Save",
  "v3.elements.fiche.equipe": "Team",
  "v3.elements.fiche.estimation": "Estimate (points)",
  "v3.elements.fiche.etat": "State",
  "v3.elements.fiche.etat_final": "Final state: the proofs the model requires will be checked.",
  "v3.elements.fiche.etiquette": "Label",
  "v3.elements.fiche.etiquettes": "labels",
  "v3.elements.fiche.favori": "Add to favourites",
  "v3.elements.fiche.favori_ajoute": "Added to favourites.",
  "v3.elements.fiche.favori_retire": "Removed from favourites.",
  "v3.elements.fiche.fusionner": "Merge a duplicate",
  "v3.elements.fiche.generer_enfants": "Decompose with AI",
  "v3.elements.fiche.gerer_classement": "Manage classification",
  "v3.elements.fiche.gestes": "Duplicates and deletion",
  "v3.elements.fiche.hierarchie": "Parents and children",
  "v3.elements.fiche.hierarchie_quoi": "parents and children",
  "v3.elements.fiche.ia": "AI",
  "v3.elements.fiche.ia_lancee": "AI job launched.",
  "v3.elements.fiche.impact": "impact",
  "v3.elements.fiche.importer_cas": "Import produced cases",
  "v3.elements.fiche.introuvable": "Item not found or not visible to you.",
  "v3.elements.fiche.journal": "Item log",
  "v3.elements.fiche.lancer": "Launch",
  "v3.elements.fiche.lancer_workflow": "Launch workflow",
  "v3.elements.fiche.lien_entrant": "← {{relation}}",
  "v3.elements.fiche.lien_retire": "Link removed.",
  "v3.elements.fiche.lien_sortant": "{{relation}} →",
  "v3.elements.fiche.liens": "Links and impact",
  "v3.elements.fiche.liens_quoi": "links",
  "v3.elements.fiche.membres_non_visibles": "Members not visible for this profile: {{quoi}} limited.",
  "v3.elements.fiche.ne_plus_suivre": "Unfollow",
  "v3.elements.fiche.niveau_etat": "Level: {{niveau}} · State: {{etat}}",
  "v3.elements.fiche.niveau_non_executable": "This level is not executable per the model.",
  "v3.elements.fiche.non_evalue": "Readiness not assessed.",
  "v3.elements.fiche.non_suivi": "You no longer follow this item.",
  "v3.elements.fiche.nouvel_etat": "New state",
  "v3.elements.fiche.nouvelle_acceptation": "Saved: a new acceptance is required.",
  "v3.elements.fiche.parents": "Parents",
  "v3.elements.fiche.personnes": "People and teams",
  "v3.elements.fiche.preparation": "readiness",
  "v3.elements.fiche.preuve_fraiche": "Proof up to date.",
  "v3.elements.fiche.preuve_perimee": "Proof outdated: the document changed.",
  "v3.elements.fiche.preuve_remplace": "Document replaced: attach the renewed version.",
  "v3.elements.fiche.preuve_source": "source document proof",
  "v3.elements.fiche.preuves": "Proofs",
  "v3.elements.fiche.produire_changement": "Produce the change",
  "v3.elements.fiche.racine": "Root item.",
  "v3.elements.fiche.rattachee": "Version attached.",
  "v3.elements.fiche.rattacher": "Attach the version",
  "v3.elements.fiche.rattacher_axe": "Attach axis",
  "v3.elements.fiche.reevaluee": "Proof reassessed.",
  "v3.elements.fiche.reevaluer": "Reassess the proof",
  "v3.elements.fiche.relation": "Relation",
  "v3.elements.fiche.relie": "Items linked.",
  "v3.elements.fiche.relier": "Link",
  "v3.elements.fiche.relier_cas": "Link the case",
  "v3.elements.fiche.relire_code": "Review the code",
  "v3.elements.fiche.replier_impact": "Hide impact",
  "v3.elements.fiche.responsable": "Assignee",
  "v3.elements.fiche.responsable_actuel": "Current assignee: {{nom}}",
  "v3.elements.fiche.retirer": "Remove",
  "v3.elements.fiche.retirer_affectation": "Remove assignment",
  "v3.elements.fiche.retirer_favori": "Remove from favourites",
  "v3.elements.fiche.retirer_lien": "Remove link to {{autre}}",
  "v3.elements.fiche.retirer_lien_effet": "The link disappears on both sides; the items remain.",
  "v3.elements.fiche.retirer_lien_titre": "Remove the link to “{{autre}}”?",
  "v3.elements.fiche.retirer_nom": "Remove {{nom}}",
  "v3.elements.fiche.retirer_rattachement": "Remove link",
  "v3.elements.fiche.retour": "Back to items",
  "v3.elements.fiche.rubrique": "Component",
  "v3.elements.fiche.rubrique_actuelle": "Component: {{nom}}",
  "v3.elements.fiche.rubriques": "components",
  "v3.elements.fiche.sans_parent_ni_enfant": "No parent or child.",
  "v3.elements.fiche.sans_preuve_source": "No source document attached.",
  "v3.elements.fiche.suivi": "You follow this item.",
  "v3.elements.fiche.suivre": "Follow the item",
  "v3.elements.fiche.supprimer": "Delete the item",
  "v3.elements.fiche.titre": "Item page",
  "v3.elements.fiche.titre_champ": "Item title",
  "v3.elements.fiche.version_actuelle": "Target release: {{nom}}",
  "v3.elements.fiche.version_cible": "Target release",
  "v3.elements.fiche.version_renouvelee": "Renewed version",
  "v3.elements.fiche.versions": "Releases",
  "v3.elements.fiche.versions_cibles": "target releases",
  "v3.elements.fiche.voir_cadence": "View cadence",
  "v3.elements.fiche.voir_couverture": "View coverage",
  "v3.elements.fiche.vous_etes_auteur": "you are its author",
  "v3.elements.fiche.workflow": "Workflow",
  "v3.elements.fiche.workflow_etapes": "Steps: {{etapes}}",
  "v3.elements.fiche.workflows": "workflows",
  "v3.elements.fusion.aide_conserve": "Another item of the same level; the current item will be absorbed.",
  "v3.elements.fusion.apercu": "merge preview",
  "v3.elements.fusion.aucun_candidat": "No other item of the same level to keep.",
  "v3.elements.fusion.bouton": "Merge",
  "v3.elements.fusion.choisir": "Choose the item to keep",
  "v3.elements.fusion.cible": "Kept: {{titre}} (#{{id}})",
  "v3.elements.fusion.conserve": "Item kept",
  "v3.elements.fusion.deplaces": "Moved to the kept item: {{liste}}",
  "v3.elements.fusion.irreversible": "The merge is final: the absorbed item cannot be reopened.",
  "v3.elements.fusion.motif": "Merge reason",
  "v3.elements.fusion.motif_aide": "At least {{min}} characters, recorded in the log.",
  "v3.elements.fusion.references": "The kept item’s reference stays unchanged.",
  "v3.elements.fusion.relu": "I have read the merge effects.",
  "v3.elements.fusion.source": "Absorbed then deleted: {{titre}} (#{{id}})",
  "v3.elements.fusion.succes": "Merge done.",
  "v3.elements.fusion.titre": "Merge a duplicate",
  "v3.elements.fusion.vide": "Choose the item to keep to see the merge effects.",
  "v3.elements.geste.erreur": "The action failed. Try again.",
  "v3.elements.geste.refus": "Action refused.",
  "v3.elements.ia.arret_organisation": "AI is stopped by the organisation: AI actions are suspended.",
  "v3.elements.ia.arret_plateforme": "AI is stopped platform-wide: AI actions are suspended.",
  "v3.elements.ia.disponible": "AI is available.",
  "v3.elements.liste.affichages": "Views",
  "v3.elements.liste.agent": "An agent",
  "v3.elements.liste.arbre": "item hierarchy",
  "v3.elements.liste.avancement": "{{termines}} / {{total}} done",
  "v3.elements.liste.changer_etat": "Change the state of {{titre}}",
  "v3.elements.liste.classement": "Classification",
  "v3.elements.liste.commandes_graphe": "Graph controls",
  "v3.elements.liste.creer": "Create an item",
  "v3.elements.liste.de": "From",
  "v3.elements.liste.deplier": "Expand {{titre}}",
  "v3.elements.liste.effacer": "Clear filters ({{nombre}})",
  "v3.elements.liste.elements": "items",
  "v3.elements.liste.entrer_selection": "Select items",
  "v3.elements.liste.equipe": "Team {{nom}}",
  "v3.elements.liste.etat_change": "State changed.",
  "v3.elements.liste.etat_ia": "AI state",
  "v3.elements.liste.filtre_cadence": "Cadence",
  "v3.elements.liste.filtre_etat": "State",
  "v3.elements.liste.filtre_etiquette": "Label",
  "v3.elements.liste.filtre_niveau": "Level",
  "v3.elements.liste.filtre_priorite": "Priority",
  "v3.elements.liste.filtre_responsable": "Assignee or team",
  "v3.elements.liste.filtre_texte": "Search (text or reference)",
  "v3.elements.liste.filtres": "Filters",
  "v3.elements.liste.flux": "Cumulative flow",
  "v3.elements.liste.formule": "{{nom}} score: {{criteres}}.",
  "v3.elements.liste.graphe": "item graph",
  "v3.elements.liste.ia": "AI and missions",
  "v3.elements.liste.lancer_mission": "Launch a mission",
  "v3.elements.liste.legende": "Relations: {{relations}}",
  "v3.elements.liste.limite": "{{colonne}}: {{compte}} / {{max}}",
  "v3.elements.liste.limite_etat.atteinte": "(reached)",
  "v3.elements.liste.limite_etat.depassee": "(exceeded)",
  "v3.elements.liste.limite_etat.sous_limite": "(below limit)",
  "v3.elements.liste.limites": "Work-in-progress limits",
  "v3.elements.liste.limites_non_definies": "No limit defined.",
  "v3.elements.liste.manquants_zero": "A missing value counts as zero.",
  "v3.elements.liste.missions": "Missions",
  "v3.elements.liste.missions_vide": "No linked mission.",
  "v3.elements.liste.modele": "Model {{modele}}, version {{version}} (frozen)",
  "v3.elements.liste.modifier_selection": "Edit selection",
  "v3.elements.liste.moi": "Me",
  "v3.elements.liste.niveaux": "Levels: {{niveaux}}",
  "v3.elements.liste.non_assigne": "Unassigned",
  "v3.elements.liste.non_prete": "Not ready: {{manques}}",
  "v3.elements.liste.onglet.graphe": "Graph",
  "v3.elements.liste.onglet.hierarchie": "Hierarchy",
  "v3.elements.liste.onglet.liste": "List",
  "v3.elements.liste.onglet.preparation": "Ready to build",
  "v3.elements.liste.onglet.tableau": "Board",
  "v3.elements.liste.prete": "Ready",
  "v3.elements.liste.prets": "items ready to build",
  "v3.elements.liste.prets_vide": "No item assessed for building.",
  "v3.elements.liste.quitter_selection": "Leave selection",
  "v3.elements.liste.rang_annonce": "Rank saved.",
  "v3.elements.liste.rang_saisi": "Rank {{rang}}",
  "v3.elements.liste.recentrer": "Recenter",
  "v3.elements.liste.rediger": "Write the specifications",
  "v3.elements.liste.regler_limites": "Set limits",
  "v3.elements.liste.relation": "Relation",
  "v3.elements.liste.reordonner": "Reorder {{titre}} (Space, arrows, Enter)",
  "v3.elements.liste.replier": "Collapse {{titre}}",
  "v3.elements.liste.sans_cadence": "No cadence",
  "v3.elements.liste.sans_relation": "No relation between items.",
  "v3.elements.liste.score": "priority score",
  "v3.elements.liste.score_valeur": "Score {{score}}",
  "v3.elements.liste.selection": "Selection ({{nombre}})",
  "v3.elements.liste.selectionner": "Select {{titre}}",
  "v3.elements.liste.titre": "Product items",
  "v3.elements.liste.trier_score": "Sort by score",
  "v3.elements.liste.vers": "To",
  "v3.elements.liste.vide": "No item in this project.",
  "v3.elements.liste.vide_filtre": "No item matches the filters.",
  "v3.elements.liste.vider_selection": "Clear selection",
  "v3.elements.liste.zoom_arriere": "Zoom out",
  "v3.elements.liste.zoom_avant": "Zoom in",
  "v3.elements.modele": "project model",
  "v3.elements.priorite.critical": "Critical",
  "v3.elements.priorite.high": "High",
  "v3.elements.priorite.low": "Low",
  "v3.elements.priorite.medium": "Medium",
  "v3.elements.sans_projet": "Choose a project to see its items.",
  "v3.elements.supprimer.bouton": "Delete permanently",
  "v3.elements.supprimer.cible": "Item to delete: {{titre}}",
  "v3.elements.supprimer.confirmer": "I understand that the deletion is final.",
  "v3.elements.supprimer.effets": "deletion effects",
  "v3.elements.supprimer.enfants": "Children affected: {{nombre}}",
  "v3.elements.supprimer.enfants_exiges": "Tick “include children”: this item has {{nombre}}.",
  "v3.elements.supprimer.inclure_enfants": "Also delete its {{nombre}} children: {{noms}}",
  "v3.elements.supprimer.irreversible": "This deletion is final: nothing can be restored.",
  "v3.elements.supprimer.preuves": "Comments affected: {{commentaires}} · linked test cases: {{cas}}",
  "v3.elements.supprimer.sans_enfant": "This item has no children.",
  "v3.elements.supprimer.succes": "Item deleted.",
  "v3.elements.supprimer.titre": "Delete an item",
  "v3.elements.tous": "All",
  "v3.elements.toutes": "All",
  "v3.elements.vague_ulterieure": "“{{ecran}}”: screen not built yet (wave {{vague}}).",
  "v3.elements.vues.appliquer": "Saved filter",
  "v3.elements.vues.aucun": "None",
  "v3.elements.vues.aucun_filtre": "No saved filter.",
  "v3.elements.vues.aucune_vue": "No personal view.",
  "v3.elements.vues.confirmer_effet": "Project members who use it will no longer find it.",
  "v3.elements.vues.confirmer_titre": "Delete filter “{{nom}}”?",
  "v3.elements.vues.enregistre": "Saved.",
  "v3.elements.vues.enregistrer_filtre": "Save filter",
  "v3.elements.vues.enregistrer_vue": "Save as my view",
  "v3.elements.vues.filtres": "saved filters",
  "v3.elements.vues.mes_vues": "my views",
  "v3.elements.vues.nom": "Filter name",
  "v3.elements.vues.nom_defaut": "My view",
  "v3.elements.vues.nom_obligatoire": "Give the filter a name.",
  "v3.elements.vues.partagees_plus_tard": "Sharing a view will come later.",
  "v3.elements.vues.supprime": "Filter deleted.",
  "v3.elements.vues.supprimer": "Delete {{nom}}",
  "v3.elements.vues.supprimer_verbe": "Delete"
}
